import './Home.css';
const SecondPContent = () => {
    return (
        <div className=" flex items-center flex-col p-9 bg-[#f5f5f5] my-1 mx-9 rounded-3xl">
            <div className="sp">
                <div className="flex justify-center">
                    <div className="w-[60%] text-center">
                        <h1 className="text-[40px] font-medium py-[10px]">Features Of School Management Software</h1>
                        <p className="text-[16px]">eSkooly is a complete and feature-rich school management software for all educational institutes. This school management software is for learning, administration, and management activities in schools, colleges, universities, tuition centers, or training centers. Our free school management system manages everything starting from admission to attendance and exams to result in cards.</p>
                    </div>
                </div>
                <div className="w-full ms flex p-8">
                    <div className="w-[33.33%] wd flex flex-col justify-evenly">
                        <div>
                            <h5 className="text-[2rem] font-medium py-[10px]">Absolutely Free</h5>
                            <p className="text-[16px]">eSkooly is an absolutely 100% free school management software for a lifetime with no limitations. No need to buy anything. Just Sign Up</p>
                        </div>
                        <div>
                            <h5 className="text-[2rem] font-medium py-[10px]">Cloud Based Software</h5>
                            <p className="text-[16px]">eSkooly is free school software that is always online, you can access it from anywhere, anytime. We will take care of your data and backups.</p>
                        </div>
                        <div>
                            <h5 className="text-[2rem] font-medium py-[10px]">Regular Updates & Support</h5>
                            <p className="text-[16px]">We add new and awesome features regularly to make our school administrative software unmatchable. Free online 24/7 support for users.</p>
                        </div>
                    </div>
                    <img src="https://eskooly.com/assets/images/play1.png" className="w-[33.33%] min-h-auto p-[60px] " alt="" />
                    <div className="w-[33.33%] wd flex flex-col justify-evenly">
                        <div>
                            <h5 className="text-[2rem] font-medium py-[10px]">Responsive Web Design</h5>
                            <p className="text-[16px]">You can use our free school management software on any device, like Mobile, Tablet, Laptop, or desktop due to its responsive design.</p>
                        </div>
                        <div>
                            <h5 className="text-[2rem] font-medium py-[10px]">Infographics & Animations</h5>
                            <p className="text-[16px]">We use infographics and animations to explain student's reports and results. Our free school software facilitates you with the optimized result.</p>
                        </div>
                        <div>
                            <h5 className="text-[2rem] font-medium py-[10px]">Fast, Secure & Easy</h5>
                            <p className="text-[16px]">We use advanced tools and technologies to build up this free school software. It is super fast, secure, reliable, and easy to use and manage.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SecondPContent;